import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Shield } from "lucide-react";

export function LoginForm({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const handleLogin = () => {
    window.location.href = "/auth/login";
  };
  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card>
        <CardHeader className="text-center">
          <CardDescription>
            Sign in with your authentik account to access HashiCorp Vault
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-6">
            <Button onClick={handleLogin} className="w-full" size="lg">
              Sign in with Authentik
            </Button>
          </div>
        </CardContent>
      </Card>
      <div className="text-muted-foreground text-center text-xs text-balance">
        Secure access to your secrets managed by HashiCorp Vault
      </div>
    </div>
  );
}
